import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { DeleteModalService } from '../../../services/delete-modal.service';
import { take } from 'rxjs/operators';
import { ChecksService } from '../../../services/checks.service';
import { CheckStorageService } from '../../../services/check-storage.service';

@Component({
  selector: 'lib-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {

  public device!: 'tablet' | 'mobile' | 'desktop';
  
  constructor( private platform: Platform,
    private deleteModalService: DeleteModalService, 
    private checkstroageService: CheckStorageService) {
    
    this.initializePlatform();
  }

  initializePlatform() {
    if( this.platform.is('mobile') ) {
      this.device = 'mobile';
    } else if ( this.platform.is('tablet') ) {
      this.device = 'tablet';
    } else if ( this.platform.is('desktop') ) {
      this.device = 'desktop';
    }
  }

  delete(): void {
    this.deleteModalService.deleteModal$.pipe(take(1)).subscribe((resp: any) => {
      const id = resp.id;
      
      if(resp.type === 'check') {
        this.checkstroageService.deleteCheck(id).subscribe(() => {
          this.deleteModalService.closeAndDeleteModal();
        });
      }

      if(resp.type === 'stationAudit') {
        this.checkstroageService.deleteStationAudit(true, id).subscribe(() => {
          this.deleteModalService.closeAndDeleteModal();
        });
      }
    });
  }
}
